<template>
  <div class="alert alert-info p-1">
    <p v-for="o in orders">
      <button type="button" @click="showInvoice(o.invoice_id)" class="btn btn-xs btn-info newWindowBtn">
        <i class="icon-fa icon-fa-eye"></i>
      </button>
      <strong>{{ o.invoice_id }}</strong> <strong>{{ Math.round(o.qty * 10) / 10 }}уп *
      {{ Math.round((o.price || o.income_price) * 10) / 10 }}</strong>
      (<i class="icon-fa icon-fa-eur"/>{{ prices[o.id] }}) <span
      v-bind:class="{red: costPrice < prices[o.id], green: costPrice > prices[o.id]}">{{
        Math.round((prices[o.id] - costPrice) * 100) / 100
      }}</span>
      <span v-if="suppliers">{{ getSupplierNameById(o.supplier_id) }}</span>
      <v-popover
        class="d-inline"
        placement="right"
        trigger="hover"
        :delay="{ show: 100, hide: 500 }"
      >
        <span class="badge badge-info pointer"><i class="icon-fa icon-fa-info"></i></span>
        <template slot="popover">
          <div v-html="costPriceCalculation ? costPriceCalculation(prices[o.id]) : 'no data'"/>
        </template>
      </v-popover>
    </p>
  </div>
</template>

<script>
export default {
  props: ['orders', 'suppliers', 'costPrice', 'costPriceCalculation'],
  data() {
    return {
      prices: {}
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  watch: {
    orders() {
      this.updatePrices();
    },
  },
  created() {
    this.updatePrices();
  },
  methods: {
    updatePrices() {
      this.orders.forEach((o) => {
        this.prices[o.id] = Math.round((o.price || o.income_price) * this.$AllCurrencies[o.currency_id].rate * 100) / 100;
      })
      this.prices = {...this.prices};
    },
    getSupplierNameById(id) {
      const s = this.suppliers.find((s) => s.id === id)
      return s ? s.title : null
    },
    showInvoice(id) {
      this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
  }
}
</script>

<style scoped>
span.red {
  color: red;
  font-weight: 700;
}

span.green {
  color: green;
  font-weight: 700;
}

.newWindowBtn {
  padding: 0px 3px !important;
}
</style>
